import { useState, useEffect, useMemo } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import userDataContext from "./userDataContext";
import { showToast } from "../../Component/Toast/Toast";


const STORAGE_KEY = "breez_user";

const generateId = () => crypto.randomUUID();

const UserDataProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  });

  // Ensure anonymous user exists
  useEffect(() => {
    if (!user) {
      const anonymousUser = { id: generateId() };
      setUser(anonymousUser);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(anonymousUser));
    } else {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
    }
  }, [user]);

  // Google login logic
  const googleLoginHandler = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: {
            Authorization: `Bearer ${tokenResponse.access_token}`,
          },
        });

        if (!res.ok) throw new Error("Invalid token");

        const userData = await res.json();

        const unifiedUser = {
          id: userData.sub,
          name: userData.name,
          email: userData.email,
          avatar: userData.picture,
          token: tokenResponse.access_token,
        };

        setUser(unifiedUser);
        showToast({ type: "success", message: "Login successful!" });
      } catch (err) {
        console.error("Google login failed");
      }
    },
    flow: "implicit",
  });

  const loginWithGoogle = () => {
    googleLoginHandler();
  };

  const logout = () => {
    const anonymousUser = { id: generateId() };
    setUser(anonymousUser);
  };

  const value = useMemo(
    () => ({
      user,
      loginWithGoogle,
      logout,
    }),
    [user],
  );

  return <userDataContext.Provider value={value}>{children}</userDataContext.Provider>;
};;;;;

export default UserDataProvider;